import React from "react";
import { Link } from "react-router-dom";
import Invite from "../../../components/landing/Invite/index";

const data = {
  title: "Free Guy (2021)",
  description:
    "A bank teller discovers that he's actually an NPC inside a brutal, open world video game.",
  imdb_rating: "8.2",
  poster: "https://cdn.zoomg.ir/2021/3/free-guy-movie-cover.jpg",
  genres: "Action/Adventure",
  time: "1h 55m",
};

const Index = () => {
  return (
    <>
      <div className="py-12">
        <div className="items-center text-center mb-10">
          <p className="inline px-4 py-2 text-xs lg:text-base bg-orange-300 rounded-full text-white">
            How it Work
          </p>
          <h1 className="text-3xl lg:text-5xl text-slate-700 font-bold mb-4 lg:leading-[72px]">
            Invite Your Partner with You
          </h1>
          <p className="text-base lg:text-lg text-slate-500 font-normal">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            <br />
            eiusmod tempor incididunt ut labore et.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-12 lg:gap-28">
          <div className="md:col-span-7 lg:col-span-5">
            <Invite data={data} />
          </div>
          <div className="md:col-span-5 lg:col-span-7">
            <div className="py-2">
              <p className="inline px-4 py-1 text-base bg-blue-300 rounded-full text-white">
                01
              </p>
              <div className="py-4">
                <h1 className="text-2xl font-bold">Sign Up to Together</h1>
                <h1 className="py-4 text-slate-500 text-lg font-normal">
                  Once you are redirected to the Sign Up Page, click "Continue"
                </h1>
              </div>
            </div>
            <div className="py-2">
              <p className="inline px-4 py-1 text-base bg-green-600 rounded-full text-white">
                02
              </p>
              <div className="py-4">
                <h1 className="text-2xl font-bold">Open a Movie in Together</h1>
                <h1 className="py-4 text-slate-500 text-lg font-normal">
                  Go to Together's website. Choose any show you would like to
                  watch and start playing the video.
                </h1>
              </div>
            </div>
            <div className="py-2">
              <p className="inline px-4 py-1 text-base bg-indigo-300 rounded-full text-white">
                03
              </p>
              <div className="py-4">
                <h1 className="text-2xl font-bold">
                  Invite People to Join a Together Party
                </h1>
                <h1 className="py-4 text-slate-500 text-lg font-normal">
                  Click on the "Invite" button under to the Movie detail, and
                  you should automatically can invite people.
                </h1>
              </div>
            </div>
            <div className="flex py-2">
              <Link
                to="/"
                className="flex w-full lg:w-fit items-center justify-center py-4 px-8 bg-sky-500 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
